import "./card.scss";

export default function Card() {
    const $videoCards = document.querySelectorAll('.video-card:not(.rest-media .video-card)');
    const $imageCards = document.querySelectorAll('.image-card');
    const $liveEventCards = document.querySelectorAll('.live-event-card');
    const today = new Date();

    if($videoCards.length) {
        $videoCards.forEach($el => {
            const $video = $el.querySelector('video') as HTMLVideoElement;
            const $playBtn = $el.querySelector('.play-btn') as HTMLElement;
            const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
            const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;

            if ($ytVideo) {
                $el.classList.add('youtube-video');
                $ytVideo.setAttribute('src', $ytVideo.src + '?enablejsapi=1');

                if($playBtn) {
                    window.addEventListener('load', () => {
                        $playBtn.addEventListener('click', () => {
                            const $infoWrapper = $el.querySelector('.info-wrapper') as HTMLElement;
                            const $titleWrapper = $el.querySelector('.title-wrapper') as HTMLElement;
                            $videoCover.classList.add('d-none');
                            $playBtn.classList.add('d-none');
                            $infoWrapper && $infoWrapper.classList.add('d-none');
                            $titleWrapper && $titleWrapper.classList.add('d-none');
                            $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                        })
                    })
                } else {
                    window.addEventListener('load', () => {
                        $el.addEventListener('click', () => {
                            const $infoWrapper = $el.querySelector('.info-wrapper') as HTMLElement;
                            const $titleWrapper = $el.querySelector('.title-wrapper') as HTMLElement;
                            $infoWrapper.classList.add('d-none');
                            $titleWrapper.classList.add('d-none');
                            $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                        })
                    })
                }
            }

            if($video) {
                $video.controls = false;
                $playBtn.addEventListener('click', () => {
                    $video.parentElement?.classList.add('full-screen');
                    $playBtn.classList.add('d-none');
                    $video.controls = true;
                })

                $video.addEventListener('ended', () => {
                    $playBtn.classList.remove('d-none');
                    $video.parentElement?.classList.remove('full-screen');
                    $video.controls = false;
                })

                $playBtn.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        $video.parentElement?.classList.add('full-screen');
                        $playBtn.classList.add('d-none');
                        $video.controls = true;
                    }
                })

                function secondsConvert(secondsDuration: any) {
                    let m = Math.floor(secondsDuration / 60);
                    secondsDuration = Math.floor(secondsDuration % 60);
                    secondsDuration = (secondsDuration >= 10) ? secondsDuration : "0" + secondsDuration;
                    return m + ":" + secondsDuration;
                }

                window.addEventListener('load', () => {
                    const $videoDuration = $el.querySelector('.time') as HTMLElement;

                    if($videoDuration) {
                        $videoDuration.innerHTML = secondsConvert($video.duration);
                    }
                })
            }
        })
    }

    if($imageCards.length) {
        $imageCards.forEach($card => {
            $card.addEventListener('click', () => {
                $card.classList.add('full-screen');
                document.body.style.overflow = 'hidden';
            })

            $card.addEventListener('keypress', (e) => {
                // @ts-ignore
                if(e.code === 'Enter') {
                    $card.classList.add('full-screen');
                    document.body.style.overflow = 'hidden';
                }
            })
        })
    }

    if($liveEventCards.length) {
        $liveEventCards.forEach($event => {
            const $startDate = $event.querySelector('.start-date') as HTMLElement;
            const $endDate = $event.querySelector('.end-date') as HTMLElement;

            const now = today.getTime();
            const dateEventStart = convertDate($startDate.innerText.trim());
            const dateEventEnd = convertDate($endDate.innerText.trim());

            if (now >= dateEventStart && now <= dateEventEnd) {
                const $flagVisible = $event.querySelector('.flag') as HTMLElement;
                $flagVisible.classList.add('is-visible');
            }

            function convertDate(date: any) {
                const [day, month, year, hours, minutes] = date.split(/[\/\s:]/);
                const dateObject = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
                return dateObject.getTime();
            }
        })
    }
}